import React from "react";
import { replaceAll } from "common";

import replaceLineBreaks from "component-library/src/components/Functional/helpers/replaceLineBreaks";
import { ReadMoreReadLess } from "component-library";

import "./FurtherInformation.scss";

export const URLS_PATTERN =
  /(https?:\/\/)?(www\.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)|(https?:\/\/)?(www\.)?(?!ww)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/gi;

export interface IFurtherInformationProps {
  text?: string;
}

export const FurtherInformation: React.FC<
  React.PropsWithChildren<IFurtherInformationProps>
> = ({ text }) => {
  let __html = replaceLineBreaks(text || "");

  const replaceTextToLink = (link: string) => {
    const htmlLink = document.createElement("a");
    htmlLink.appendChild(document.createTextNode(link));
    htmlLink.target = "_blank";
    htmlLink.href = !/^http(s?):\/\//.test(link)
      ? "http://".concat(link)
      : link;

    return htmlLink.outerHTML;
  };

  __html = replaceAll(URLS_PATTERN, __html, replaceTextToLink);

  return <ReadMoreReadLess text={__html} />;
};
